<template>
	<input class="rc-form-control" :value="modelValue" @input="updateInput" type="text">
</template>
	
<script>
export default {
	name: 'rc-input',
	props: {
		modelValue: [String, Number]
	},
	methods: {
		updateInput(e) {
			this.$emit('update:modelValue', e.target.value)
		}
	},
}
</script>
	
<style scoped>
.rc-form-control {
	font-size: 1rem;
	padding: .5rem;
	border: 1px solid #4080f0;
	border-radius: 2px;
}
</style>